import PropTypes from "prop-types";
import React, { Component } from "react";
import { Icon, Segment, Step } from "semantic-ui-react";

class DocumentRequestStep extends Component {
  handleClick = () => {
    const { step, onStepClick, isAccessible } = this.props;
    if (isAccessible && onStepClick) {
      onStepClick(step);
    }
  };

  render() {
    const {
      step,
      currentStep,
      activeStep,
      iconName,
      title,
      description,
      isAccessible,
      onStepClick,
    } = this.props;

    const isCompleted = step < currentStep;
    const isActive = activeStep === step;
    const isClickable = isAccessible && onStepClick;

    return (
      <Step
        active={isActive}
        completed={isCompleted}
        disabled={!isAccessible}
        onClick={this.handleClick}
        style={{
          cursor: isClickable ? "pointer" : "default",
          opacity: isAccessible ? 1 : 0.5,
        }}
      >
        {iconName && <Icon name={iconName} />}
        <Step.Content>
          <Step.Title className="uppercase">{title}</Step.Title>
          <Step.Description>{description}</Step.Description>
        </Step.Content>
      </Step>
    );
  }
}

DocumentRequestStep.propTypes = {
  step: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  onStepClick: PropTypes.func,
  isAccessible: PropTypes.bool.isRequired,
};

class DocumentRequestStepsHeader extends Component {
  getCurrentStep() {
    const { docReq } = this.props;
    const { state, document_pid: documentPid } = docReq;

    if (!documentPid) return 0;
    if (state === "PENDING" || state === "REQUESTED") return 1;
    if (state === "ACCEPTED" || state === "DECLINED") return 2;
    return 1;
  }

  render() {
    const { currentStep, activeStep, onStepClick, isStepAccessible } =
      this.props;
    const displayCurrentStep =
      currentStep !== undefined ? currentStep : this.getCurrentStep();

    return (
      <Segment>
        <Step.Group size="mini" fluid widths={3}>
          <DocumentRequestStep
            step={0}
            currentStep={displayCurrentStep}
            activeStep={
              activeStep !== undefined ? activeStep : displayCurrentStep
            }
            iconName="book"
            title="Select document"
            description="Select a document for this request."
            onStepClick={onStepClick}
            isAccessible={isStepAccessible ? isStepAccessible(0) : true}
          />
          <DocumentRequestStep
            step={1}
            currentStep={displayCurrentStep}
            activeStep={
              activeStep !== undefined ? activeStep : displayCurrentStep
            }
            iconName="handshake outline"
            title="accept"
            description="Accept the request."
            onStepClick={onStepClick}
            isAccessible={isStepAccessible ? isStepAccessible(1) : true}
          />
          <DocumentRequestStep
            step={2}
            currentStep={displayCurrentStep}
            activeStep={
              activeStep !== undefined ? activeStep : displayCurrentStep
            }
            iconName="check"
            title="completed"
            description="Request accepted or declined."
            onStepClick={onStepClick}
            isAccessible={isStepAccessible ? isStepAccessible(2) : true}
          />
        </Step.Group>
      </Segment>
    );
  }
}

DocumentRequestStepsHeader.propTypes = {
  docReq: PropTypes.object.isRequired,
  currentStep: PropTypes.number,
  activeStep: PropTypes.number,
  onStepClick: PropTypes.func,
  isStepAccessible: PropTypes.func,
};

export { DocumentRequestStepsHeader };
